<template>
    <div class="empty-container">
        <img v-if="showPic" src="@/assets/images/pic_zanwushuju.png" alt="暂无数据" class="empty-image" />
        <p class="empty-text">{{ $t('public.noData') || '暂无数据' }}</p>
    </div>
</template>

<script>
export default {
    name: 'KLEmpty',
    props: {
        showPic: {
            type: Boolean,
            default: true
        }
    },
};
</script>

<style scoped>
.empty-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    text-align: center;
}

.empty-image {
    width: 30%;

    margin-bottom: 10px;
}

.empty-text {
    font-size: 14px;
    color: #666;
}
</style>